import { useQuery } from '@apollo/client'
import React, { FC, createContext, useState } from 'react'

import {
  lookbook_itemsVariables,
  lookbook_items,
} from '../__generated__/lookbook_items'

import { SortOrder } from '../__generated__/globalTypes'
import { LOOKBOOK_ITEMS } from '../queries/lookbook'
import { ILookBookItem } from '../components/types'
import { createLookBookItem } from '../lib/createLookBookItem'

interface ILookbookContext {
  loading: boolean
  hasNextPage: boolean
  loadMore: () => Promise<void>
  items: ILookBookItem[]
}
export const LookbookContext = createContext({} as ILookbookContext)

const LookbookProvider: FC = ({ children }) => {
  const [cursor, setCursor] = useState<string>('')

  const loadMore = async () => {
    await fetchMore({
      variables: {
        where: {
          iblock: {
            code: {
              equals: 'lookbook',
            },
          },
          active: {
            equals: true,
          },
        },
        first: 4,
        order: { sort: SortOrder.asc },
        after: cursor,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        setCursor(fetchMoreResult?.elements?.pageInfo?.endCursor)
        if (fetchMoreResult.elements.nodes) {
          const obj = {
            ...prev,
            ...fetchMoreResult,
            elements: {
              ...prev.elements,
              ...fetchMoreResult.elements,
              nodes: [
                ...prev.elements.nodes,
                ...fetchMoreResult.elements.nodes,
              ],
              pageInfo: {
                ...prev.elements.pageInfo,
                ...fetchMoreResult.elements.pageInfo,
              },
            },
          }

          return obj
        }
        return prev
      },
    })
  }

  const { loading, fetchMore, data, error } = useQuery<
    lookbook_items,
    lookbook_itemsVariables
  >(LOOKBOOK_ITEMS, {
    variables: {
      where: {
        iblock: {
          code: {
            equals: 'lookbook',
          },
        },
        active: {
          equals: true,
        },
      },
      first: 4,
      order: { sort: SortOrder.asc },
    },
    onCompleted: (data) => {
      if (!loading && !error) {
        setCursor(data?.elements?.pageInfo?.endCursor)
      }
    },
  })

  const hasNextPage = data?.elements?.pageInfo?.hasNextPage
  const items = data?.elements?.nodes?.map((node) => createLookBookItem(node))

  return (
    <LookbookContext.Provider
      value={{
        loading,
        hasNextPage,
        loadMore,
        items,
      }}
    >
      {children}
    </LookbookContext.Provider>
  )
}

export default LookbookProvider
